import { createSelector } from "reselect";
import makeGetVideoEntity from "selectors/makeGetVideoEntity";

const BITRATES = {
  HIGH: 3626, // 1080
  VERY_HIGH: 6250, // 2k
};

export default function makeGetInitialDashBitrate() {
  const getVideoEntity = makeGetVideoEntity();
  return createSelector(getVideoEntity, (videoEntity) => {
    if (videoEntity.is360) {
      return BITRATES.VERY_HIGH;
    }
    return BITRATES.HIGH;
  });
}
